// @core/api/endpoints/subscription/get_entitlement.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EntitlementResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get entitlement details
 * Retrieves full entitlement details including source plan, usage, and limits.
 */
export async function GetEntitlement(
  entitlement_id: string,
  options?: RequestOptions
): Promise<EntitlementResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/entitlements/:entitlement_id`;
  requestPath = requestPath.replace(':entitlement_id', encodeURIComponent(entitlement_id));
  const requestOptions = options;
  return client.get<EntitlementResponse>(requestPath, { ...requestOptions });
}
